import React, { Component, useState } from 'react'
import "./PaymentSummary.css"
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import Loader from "./../../components/CustomLoader";
import client from "./../../utils/apolloClient";
import getData from "./../../data-services/api";
import { getUser } from "./../../data-services/queries";
import gql from "graphql-tag";
import _ from "lodash";
import noResultFoundImage from "../MyFCP/images/noResultFoundImage.png";

export default class PaymentSummery extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            PaymentDetails: []
        };

    }

    async componentDidMount() {
        await client
            .query({
                query: gql(getUser)
            })
            .then(({ data }) => {
                if (data.user.role === "FCP") {
                    this.setState({
                        userData: data.user
                    });
                }
            });

        let PaymentDetails;
        PaymentDetails = await getData(
            `select id, name, Invoice_Booking_Rejection_Remark__c, Invoice_Number__c, Payment_Document_Number__c, Payment_Date__c,
                Amount, Paid_Amount__c,Payment_Status_Remark__c, stagename, Account_Approval_Date__c from salesforce.Opportunity where
                 EXTRACT(YEAR FROM start_date_time__c) = EXTRACT(YEAR FROM CURRENT_DATE) and AccountId ='${this.state.userData.sfid}'
                 ORDER BY end_date_time__c DESC;`
        )
      // console.log("PaymentDetails Data", PaymentDetails);

        this.setState({
            PaymentDetails: PaymentDetails.result,
        });
    }

    render() {
        const { loading, PaymentDetails } = this.state;
        const { classes, history, } = this.props;

        return (
            <>
                <AppBar position="static">
                    <Toolbar>
                        <Grid item xs={2} sm={2} md={2}>
                            <IconButton
                                color="inherit"
                                aria-label="Menu"
                                onClick={() => {
                                    history.goBack();
                                }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={8} sm={8} md={8}>
                            <Typography
                                variant="title"
                                color="inherit"
                                className='text-center'
                            >
                                Payment Summary
                            </Typography>
                        </Grid>
                    </Toolbar>
                </AppBar>
                {PaymentDetails.length > 0 ?
                    <>
                        <div>
                            <div className='paymentSummery'>
                                {PaymentDetails && PaymentDetails.map((item) => {
                                    return (
                                            <div className="paymentSummery_OuterBox">
                                                <div className="paymentSummery_DetailsBox">
                                                    <div className="paymentSummery_UpperBox">
                                                        <div className='paymentSummery_titleLeftBox'>
                                                            <div className='paymentSummery_title'>{item.name}</div>
                                                            <div className='paymentSummery_titleDate'>Payment date - {item.payment_date__c}</div>
                                                            <div className='paymentSummery_titleDate'>Account approve date - {item.account_approval_date__c}</div>
                                                        </div>
                                                        <div className='paymentSummery_Rbox'>
                                                            <div className='paymentSummery_titleRightBox'>
                                                                {item.payment_status_remark__c ? <p className='paymentSummery_success'>PAYMENT SUCCESSFUL</p> : 
                                                                <p className='paymentSummery_pending'>PAYMENT PENDING</p>}
                                                            </div>
                                                            <div className='paymentSummery_titleRightDate'>{item.stagename}</div>
                                                        </div>
                                                    </div>
                                                    {/* {item.payment_date__c == 'null' ? 
                                                    <></>
                                                    : <></>
                                                    } */}
                                                    <div className="paymentSummery_LowerBox">
                                                        <div className='d-flex justify-content-center'>
                                                            <div className='paymentSummery__detailBox3'>
                                                                <div className='paymentSummery__detailLabel'>PD Number</div>
                                                                <div className='paymentSummery__detailValue'>
                                                                    {item.payment_document_number__c ? item.payment_document_number__c : "-"}
                                                                </div>
                                                            </div>
                                                            <div className='paymentSummery__detailBox3'>
                                                                <div className='paymentSummery__detailLabel'>Invoice No</div>
                                                                <div className='paymentSummery__detailValue'>
                                                                    {item.invoice_number__c ? item.invoice_number__c : "-"}
                                                                </div>
                                                            </div>
                                                            <div className='paymentSummery__detailBox4'>
                                                                <div className='paymentSummery__detailLabel'>Amount</div>
                                                                <div className='paymentSummery__detailValue'>
                                                                    {item.paid_amount__c ? `₹${item.paid_amount__c}` : "-"}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </> :
                    <Grid container spacing={8} justify="center" alignItems="center">
                        <img style={{ marginTop: '50px', width: 220, height: 190 }} src={noResultFoundImage} />
                    </Grid>
                }
            </>
        )
    }
}